import { useQuery } from '@tanstack/react-query';
import { fetchScheduleActivities } from '@/features/accounts/api';

export function useScheduleActivities(scheduleId: number, enabled = true) {
  return useQuery({
    queryKey: ['scheduleActivities', scheduleId],
    queryFn: () => fetchScheduleActivities(scheduleId),
    enabled,
  });
}
